// import Button from "../common/Button/Button";
import classes from "./HcV.module.css";
// import about from "./about.svg";//
// import SRMUL from "./SRMULOGO.jpg";
import HCV from "./HCV.png"

const vivekainsta = "https://www.instagram.com/srmulucknow_official/";
const vivekalinkedin = "https://www.linkedin.com/school/shri-ramswaroop-memorial-university/";
const sambhavitwitter = "https://www.facebook.com/@SRMUOFFICIAL/";

const HcV = () => {
  return (
    <>
      <section id="about" className={classes.aboutSec}>
        <div className={classes.about}>
          <div className={classes.details}>
            <h3 className={classes.heading}>Chief Guest</h3>
            <h2 className={classes.heading1}>Prof(Dr.) H. C. Verma </h2>
            <p className={classes.para}>
            <strong >Prof. Harish Chandra Verma </strong> is one of the most distinguished authors of Physics in India. Often referred to as an 'idol' and the pedagogical 'Guru' for all JEE aspirants, he has written several influential books on Physics and is best known for his two-volume book Concepts of Physics. The book is considered as the Bible of Physics, a prerequisite for students preparing for IIT JEE or other engineering entrance examinations. Currently, he serves as a Professor in the Department of Physics at IIT Kanpur. Besides being a prominent author and researcher, he is an active socialist who has co-founded many social initiatives like Shikhsa Sopan, which literally means "a ladder to education" for the growth and upliftment of underprivileged kids in and around IIT campus.
            </p>

            {/* <div className={classes.footer_social_item}>
                        <div>
                          <a
                            href={vivekainsta}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.footer_a_link}
                          >
                            <img
                              className={classes.footer_social_link}
                              src="https://img.icons8.com/fluency/48/ffffff/instagram-new.png"
                              alt=""
                            />
                          </a>
                        </div>
                        <div>
                          <a
                            href={vivekalinkedin}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.footer_a_link}
                          >
                            <img
                              className={classes.footer_social_link}
                              src="https://img.icons8.com/color/48/ffffff/linkedin-circled--v1.png"
                              alt=""
                            />
                          </a>{" "}
                        </div>
                        <div>
                          <a
                            href={sambhavitwitter}
                            target="_blank"
                            rel="noopener noreferrer"
                            className={classes.footer_a_link}
                          >
                            <img
                              className={classes.footer_social_link}
                              src="https://img.icons8.com/fluency/48/ffffff/facebook-circled.png"
                              alt=""
                            />
                          </a>{" "}
                        </div>
            </div> */}
            
            {/* <p className={classes.para}>
            Spectacular talent stretches boundaries to inspire the participating
            students and the rapt audience alike. A gigantic range of events
            from advanced robotics challenges to entrepreneurship hunts
            promising to zap up the cranial indices of participants. Skill,
            genius and knowledge trading infused with a handful of fun, and a
            titanic prize money sum of above half a million rupees to make Karma
            one of the most unique tech carnivals of the country.
          </p> */}
            {/* <div className={classes.btn}>
            <Button label="Explore" />
          </div> */}
          </div>

          <div className={classes.composition}>
            <img className={classes.images} src={HCV} alt="about" />
          </div>
        </div>
       {/* About viveka */}
        {/* <div className={classes.about}>
          <div className={classes.details}>
            <h3 className={classes.heading}>About</h3>
            <h2 className={classes.heading1}>Viveka 4.0 </h2>
            <p className={classes.para}>
              <strong>
                VIVEKA:<i>The Intelligence 4.0</i>
              </strong>{" "}
              is the Annual Techfest of Shri Ramswaroop Memorial University
              organized under the initiative of Tech Fusion Club. Unleash your
              technical skills in the vast horizon of events.
            </p>

            <p className={classes.para}>
              <strong>Viveka: The Intelligence 4.0</strong> promises a thrilling
              experience for all tech enthusiasts. We are writing to you with
              the hope that your esteemed organization will consider sponsoring
              our event.
            </p>

            <p className={classes.para}>
            Spectacular talent stretches boundaries to inspire the participating
            students and the rapt audience alike. A gigantic range of events
            from advanced robotics challenges to entrepreneurship hunts
            promising to zap up the cranial indices of participants. Skill,
            genius and knowledge trading infused with a handful of fun, and a
            titanic prize money sum of above half a million rupees to make Karma
            one of the most unique tech carnivals of the country.
          </p> 
            <div className={classes.btn}>
            <Button label="Explore" />
          </div>
          </div>

          <div className={classes.composition}>
            <img className={classes.images} src={about} alt="about" />
          </div>
        </div> */}
      </section>
    </>
  );
};

export default HcV;
